import React, { useState } from 'react';
import {Box, Typography, Button, Hidden, Grid } from '@mui/material';
import Modal from '../../components/Modal';
import DrawerComponent from '../../components/Drawer';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { config } from '../../wsclient/crmservices/config';
import { config_path } from '../../router/config.path';
import { logOut } from '../../utils/common';

export default function GuestInfo() {
    const [open, setOpen] = useState(true);
    const { t } = useTranslation();
    const navigate = useNavigate();
    
    const handleClose = () => {   
        navigate(config_path.home);
        setOpen(false);
    }
    const handleGuest = () => {
        navigate(config_path.home);
    };

    const handleRegister = () => {
        logOut(undefined, navigate)
    };

  const renderRoot = () => {
  return (
    <>
        <Hidden mdDown>
            <Modal isOpen={open} onClose={handleClose} titleAlign={'left'} enableCloseButton>
                {renderContent()}
            </Modal>
        </Hidden>
        <Hidden mdUp>
            <DrawerComponent isOpen={open} onClose={handleClose}>
                {renderContent()}
            </DrawerComponent>
        </Hidden>
    </>
  )}

  const renderContent = () => {
        return (
            <Box>
                <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="subtitle2" mb={2} textAlign="center">{t('register_guest_info')}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Button variant="outlined" fullWidth onClick={handleGuest}>{t('btn_guest_login')}</Button>
                </Grid>
                <Grid item xs={12}>
                    <Button variant="contained" fullWidth onClick={handleRegister}>{t('btn_register_now')}</Button>
                </Grid>
                </Grid>
            </Box>
            );}

  return (
        <>{renderRoot()}</>
    )
}
